module.exports = __webpack_public_path__ + "static/media/compass.7efa294e.svg";